const data_experience = [
  {
    name: 'Chau Hoai Vu',
    experiences: [
      {
        title: 'UI/UX Design',
        description:
          'Design involves creating interfaces for machines and software like computers, tablet, and mobiles.',
        years: '1 year'
      },
      {
        title: 'React Developers',
        description:
          'React developer in crafting dynamic, user-centric interfaces, optimizing performance, and ensuring seamless functionality.',
        years: '1 year'
      },
      {
        title: 'Team Collaboration',
        description:
          'Collaborated seamlessly in cross-functional teams for efficient frontend project development.',
        years: '2 years'
      },
      {
        title: 'Adaptive Web Design',
        description:
          'Crafting adaptable layouts for optimal, responsive user experiences on all devices seamlessly.',
        years: '1 year'
      }
    ]
  },
  {
    name: 'Nguyen Duc Nam',
    experiences: [
      {
        title: 'Agile Scrum Methodologies',
        description:
          'Proficient in Agile Scrum for frontend, ensuring iterative development, collaboration, and client satisfaction.',
        years: '3 months'
      },
      {
        title: 'Web Development',
        description:
          'Crafting adaptable layouts for optimal, responsive user experiences on all devices seamlessly.',
        years: '1 year'
      },
      {
        title: 'UI/UX Design',
        description:
          'Design involves creating interfaces for machines and software like computers, tablet, and mobiles.',
        years: '1 year'
      },
      {
        title: 'Blockchain',
        description:
          'Proficient in blockchain technology, including smart contracts, decentralized apps, and secure transaction validation.',
        years: '6 months'
      }
    ]
  },
  {
    name: 'Tran Trieu Tuan',
    experiences: [
      {
        title: 'Adaptive Web Design',
        description:
          'Crafting adaptable layouts for optimal, responsive user experiences on all devices seamlessly.',
        years: '1 year'
      },
      {
        title: 'Problem-Solving',
        description:
          'Problem-solving skills honed through analyzing complex issues and implementing effective solutions in various scenarios.',
        years: '1 year'
      },
      {
        title: 'JavaScript Proficiency',
        description:
          'Crafting interactive web elements, dynamic functionalities, and solving complex problems with code versatility.',
        years: '1 year'
      },
      {
        title: 'UI/UX Design',
        description:
          'Design involves creating interfaces for machines and software like computers, tablet, and mobiles.',
        years: '1 year'
      }
    ]
  }
]

export default data_experience
